export const LOAD_LOGS_SUCCEEDED = "LOAD_LOGS_SUCCEEDED";
export const LOAD_LOGS_FAILED = "LOAD_LOGS_FAILED";
export const LOAD_LOGS_STARTED = "LOAD_LOGS_STARTED";

export const LOAD_DOWNLOADPATH_SUCCEEDED = "LOAD_DOWNLOADPATH_SUCCEEDED";
export const LOAD_DOWNLOADPATH_FAILED = "LOAD_DOWNLOADPATH_FAILED";

export const LOAD_LEVELS_SUCCEEDED = "LOAD_LEVELS_SUCCEEDED";
export const LOAD_LEVELS_FAILED = "LOAD_LEVELS_FAILED";

export const LOAD_LOG_SUCCEEDED = "LOAD_LOG_SUCCEEDED";
export const LOAD_LOG_FAILED = "LOAD_LOG_FAILED";
export const LOAD_LOG_STARTED = "LOAD_LOG_STARTED";
